class DropDown {
  static init() {
    
    const closeAllDropdownMenus = (current) => {
      const DROPDOWN_MENUS = document.querySelectorAll('[data-cs-selector="dropdown-menu"]');
      DROPDOWN_MENUS.forEach((MENU) => {
        if (MENU !== current) {
          MENU.classList.remove('open');
          MENU.parentElement.querySelector('[data-cs-toggle="dropdown"]').setAttribute('aria-expanded', false)
        }
      });
    };

    const openDropDownMenu = (selector) => {
      const TARGET = document.querySelector(selector);
      closeAllDropdownMenus(TARGET);
      TARGET.classList.toggle('open');
    };

    const attrToggle = (el, attr) => el.getAttribute(attr) == 'false' ? el.setAttribute(attr, "true") : el.setAttribute(attr, "false");

    document.addEventListener('click', (event) => {
      const MATCH_TOGGLE = event.target.matches('[data-cs-toggle="dropdown"]');

      if (MATCH_TOGGLE) {
        const DROPDOWN_TOGGLE = event.target;
        const TARGET_SELECTOR = DROPDOWN_TOGGLE.dataset.csTarget;

        if (TARGET_SELECTOR && !DROPDOWN_TOGGLE.classList.contains('disabled')) {
          
          attrToggle(DROPDOWN_TOGGLE, 'aria-expanded');
          
          if (DROPDOWN_TOGGLE.parentElement.querySelector(TARGET_SELECTOR)) {
            const TARGET = DROPDOWN_TOGGLE.parentElement.querySelector(TARGET_SELECTOR);
            const TARGET_CHILDREN = TARGET.childNodes;

            TARGET_CHILDREN.forEach(child => {
              child.addEventListener('click', (e) => {
                const SELECTION = e.currentTarget.querySelector('[data-cs-dropdown="selected-value"]').innerHTML;
  
                DROPDOWN_TOGGLE.classList.add('selected');
                DROPDOWN_TOGGLE.querySelector('[data-js-dropdown-value]').innerHTML = SELECTION;

                attrToggle(DROPDOWN_TOGGLE, 'aria-expanded');
              });
            });

            openDropDownMenu(TARGET_SELECTOR);
          }
        }
      } else if (!MATCH_TOGGLE ) {
        closeAllDropdownMenus();
      }
    });
  }
}

export { DropDown };
